<template>
  <generic-container
    class="ui container"
    :title="$t('task') + task_title"
    icon="list"
    :wide="wide"
    :header_buttons="header_buttons"
    ref="container"
    id="cntnr"
  >
    <div class="ui form" id="instance_form"></div>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import filters from "@/filters";
import Vue from "vue";
import { local_api, error_toast } from "@/utils";
import { clone, cloneDeep } from "lodash";
// import { success_toast } from "../../utils";

export default {
  name: "NgineWorkspaceExternalTaskViewer",
  components: { GenericContainer },
  data: function() {
    return {
      permantent_buttons: [
        {
          icon: "arrows alternate horizontal",
          color: "",
          click: this.toggle_wide,
          tooltip: this.$t("toggle size"),
        },
      ],
      task: undefined,
      user_task_vue: undefined,
      wide: true,
      task_common_buttons: [
        {
          icon: "blue save",
          click: this.save_task_data,
          tooltip: this.$t("save task data"),
        },
      ],
      header_buttons: [],
    };
  },
  computed: {
    task_title() {
      if (this.task) return ` | ${this.task.title}`;
      else return "";
    },
  },
  methods: {
    clear() {
      this.task = undefined;
      window.jQuery("#instance_form").empty();
      this.header_buttons = [];
    },
    toggle_wide() {
      this.wide = !this.wide;
    },
  },
  beforeCreate() {},
  mounted() {
    let vm = this;
    if (!window.jQuery("#instance_form").length) {
      let x = window.jQuery("#cntnr .bottom.attached.segment");
      x.html('<div class="ui form" id="instance_form"></div>');
    }
    vm.$refs.container.set_loading(true);

    let instance_uuid = vm.$route.query.i;
    let element_id = vm.$route.query.e;

    local_api(vm, "post", "/ngine_workspace/external/do-get-task", {
      i: instance_uuid,
      e: element_id,
    })
      .then((_task) => {
        vm.task = _task;

        /** Show buttons */
        vm.header_buttons = vm.permantent_buttons.concat(
          vm.task_common_buttons,
        );

        // window.jQuery("#instance_form").empty();

        // let setup = JSON.parse(task.setup);
        let userTaskPayload = _task.payload_in || {};
        let V = {};

        let variables = _task.variables;
        variables.map((v) => {
          V[v.name] = v.value;
        });

        let html = `<div class="ui basic icon labeled button"
                    v-for="(outcome, index) in outcomes"
                    :key="index"
                    style="margin-bottom: 20px"
                    @click="submit_data(outcome)"
                  >
                    <i :class="outcome.icon + ' icon'"></i> {{ outcome.name }}
                  </div>${_task.setup.human_task.html}<div class="ui error message" />`;

        //let targetElement = window.jQuery("#instance_form");
        /*if (!targetElement.length)
            window
              .jQuery(vm.$refs.container)
              .append(
                `<div class="ui form" id="instance_form" ref="instance_form"></div>`
              );*/

        window.jQuery("#instance_form").html(html);

        var mixin = {};
        var fields = {};
        // eslint-disable-next-line no-unused-vars
        var validate_on = [];
        try {
          // eslint-disable-next-line no-unused-vars
          var moment = require("moment");
          _task.setup.human_task.modifiers
            .filter((m) => m.type == "js")
            .map((m) => {
              eval(m.code);
            });

          Vue.config.errorHandler = function(err) {
            error_toast(
              `${vm.$t(
                "an error ocurred during screen initialization",
              )}. ${vm.$t("error")}: ${err.toString()}`,
            );
            vm.$refs.container.set_loading(false);
          };

          userTaskPayload.outcomes = _task.setup.human_task.outcomes;
          userTaskPayload.V = V;

          // window.jQuery("#instance_form").form();
          if (_task.setup.human_task.mixin)
            eval(`mixin = ${_task.setup.human_task.mixin}`);

          vm.user_task_vue = new Vue({
            el: "#instance_form",
            data: function() {
              let obj = cloneDeep(userTaskPayload);
              obj.form = undefined;
              return obj;
            },
            filters: filters,
            mixins: [mixin],
            methods: {
              submit_data(outcome) {
                let vm_ = this;
                if (outcome.validate) {
                  if (_task.setup.human_task.validation)
                    eval(`fields = ${_task.setup.human_task.validation}`);
                  vm_.form
                    .form({
                      fields: fields,
                      onSuccess() {
                        vm_.do_submit(outcome);
                      },
                    })
                    .form("validate form");
                } else {
                  vm_.do_submit(outcome);
                }
              },
              do_submit(outcome) {
                let vm_ = this;
                vm.$refs.container.set_loading(true);

                let data = clone(vm_.$data);
                delete data.V;
                delete data.outcomes;
                delete data.form;

                local_api(
                  vm,
                  "post",
                  "/ngine_workspace/external/do-submit-task",
                  {
                    t: _task.uuid,
                    d: data,
                    o: outcome.name,
                  },
                )
                  .then((r) => {
                    vm.$refs.container.set_loading(false);
                    if (vm_.submitted && typeof vm_.submitted == "function") {
                      vm_.submitted(r);
                    }
                  })
                  .catch((err) => {
                    error_toast(err);
                  });
              },
            },
            mounted() {
              let vm_ = this;
              vm.$refs.container.set_loading(false);
              vm_.form = window.jQuery(vm_.$el).form();
            },
          });
        } catch (error) {
          error_toast(error);
        }
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  watch: {},
};
</script>
